import { render, staticRenderFns } from "./MainMenuPanel.vue?vue&type=template&id=25f55878&scoped=true"
import script from "./MainMenuPanel.vue?vue&type=script&lang=js"
export * from "./MainMenuPanel.vue?vue&type=script&lang=js"
import style0 from "./MainMenuPanel.vue?vue&type=style&index=0&id=25f55878&prod&scoped=true&lang=css"
import style1 from "./MainMenuPanel.vue?vue&type=style&index=1&id=25f55878&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f55878",
  null
  
)

export default component.exports